import type { FC, ReactNode } from 'react'

import { delay } from '@/lib/ui'
import { SplitWords } from '@/components/generals/split-words'
import { ABOUT_INDEX } from '@/constants/about'

export const AboutIndex: FC = (): ReactNode => {
    return (
        <section id='selected' className='ed-wrap pt-[clamp(28px,3.4vh,48px)]'>
            <div className='mb-[clamp(20px,3.2vh,40px)] grid gap-y-8 md:grid-cols-12 md:items-end md:gap-x-[clamp(20px,3vw,48px)]'>
                <div className='md:col-span-4'>
                    <div className='ed-label' data-reveal='up'>
                        (05) — Selected
                    </div>
                </div>

                <div className='md:col-span-8'>
                    <h2 className='ed-h2' data-reveal='words'>
                        <SplitWords text='Exhibitions and commissions' />
                    </h2>
                </div>
            </div>

            <div>
                {ABOUT_INDEX.map((row, index) => (
                    <div
                        key={`${row.year}-${row.title}`}
                        className='ed-row grid-cols-[70px_minmax(0,1fr)] md:grid-cols-[92px_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1.2fr)] md:gap-x-[clamp(20px,3vw,48px)]'
                        data-reveal='up'
                        style={delay(index * 0.05)}
                    >
                        <span className='ed-mono text-faint'>
                            {row.year}
                        </span>

                        <span className='text-[clamp(15px,1.5vw,21px)] leading-tight tracking-[-0.015em] text-foreground'>
                            {row.title}
                        </span>

                        <span className='ed-mono col-start-2 text-faint md:col-start-auto'>
                            {row.kind}
                        </span>

                        <span className='ed-body col-start-2 md:col-start-auto'>
                            {row.venue}
                        </span>
                    </div>
                ))}
            </div>
        </section>
    )
}
